module.exports = __webpack_public_path__ + "static/media/2.3dc215b8.jpg";